import { FormProvider, useForm } from 'react-hook-form';
import { useMemo } from 'react';
import { BankQuote, LoanQuote } from '@axo/shared/data-access/types/loan_quote';
import {
  LoanQuoteDataFormValues,
  useLoanQuoteDataFormResolver,
} from './QuoteDataFormSchema';
import React from 'react';
import { LoanApplication } from '@axo/shared/data-access/types';

type LoanQuoteDataForms = React.PropsWithChildren<{
  data: BankQuote[] | undefined;
  application: LoanApplication;
}>;

export const QuoteDataForm: React.FC<LoanQuoteDataForms> = ({
  data,
  application,
  children,
}) => {
  const resolver = useLoanQuoteDataFormResolver(application);

  const values = useMemo(() => {
    // FIXME: This shouldn't have to be of type any
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const val = {} as Record<string, any>;

    data?.map((quote: BankQuote) => {
      return (val[quote.ID] = {
        ID: quote?.ID,
        Amount: quote?.Amount?.toString() || '',
        LenderMaxPossibleAmount:
          quote?.LenderMaxPossibleAmount?.toString() || '',
        Duration: quote?.Duration?.toString() || '',
        NominalRate: quote?.NominalRate?.toString() || '',
        EffectiveRate: quote?.EffectiveRate?.toString() || '',
        AnnualRate: quote?.AnnualRate?.toString() || '',
        MonthlyPayment: quote?.MonthlyPayment?.toString() || '',
        TotalPayment: quote?.TotalPayment?.toString() || '',
        StartupFee: quote?.StartupFee?.toString() || '',
        AdministrationFee: quote?.AdministrationFee?.toString() || '',
        RefinanceAmount: quote?.RefinanceAmount?.toString() || '',
        TopupAmount: quote?.TopupAmount?.toString() || '',
        DisbursedAt: quote?.DisbursedAt || undefined,
        Status: quote?.Status || undefined,
        LoanRequestID: quote?.LoanRequestID || undefined,
        LenderID: quote?.LenderID || undefined,
        LenderReference: quote?.LenderReference || undefined,
      });
    });

    return val satisfies Record<string, Partial<LoanQuote>>;
  }, [data]);

  const formMethods = useForm<LoanQuoteDataFormValues>({
    defaultValues: values,
    values,
    resolver,
    mode: 'all',
    criteriaMode: 'all',
  });

  return (
    <form
      style={{
        display: 'contents',
      }}
    >
      <FormProvider {...formMethods}>{children}</FormProvider>
    </form>
  );
};
